define([
    'handlebars',
    'modules/common/controls/select2',
    'appcontext'
], (Handlebars, Select2, appContext) => Select2.extend({

    defaults: _.extend({
        title: false
    }, Select2.prototype.defaults),

    formatSelection (state, container) {
        if (this.options.title) {
            container.attr('title', '#{0} {1}'.format(state.id, state.name));
        }

        return '{0} #{1} {2}'.format(
            Handlebars.helpers.h_channel_img(state.channel_id), state.id, _.escape(state.name)
        );
    },

    formatResult (state) {
        return '{0} #{1} {2}'.format(
            Handlebars.helpers.h_channel_img(state.channel_id), state.id, _.escape(state.name)
        );
    },

    matcher (term, text, option) {
        const pattern = term.toUpperCase();
        const channel = appContext.channels().get(option.channel_id);
        const channelName = channel ? channel.get('name') : null;

        return option.name.toUpperCase().indexOf(pattern) >= 0 ||
                `${option.id}`.indexOf(term) >= 0 ||
                (channelName ? channelName.toUpperCase().indexOf(pattern) >= 0 : false);
    }

}));
